export default __webpack_public_path__ + "static/media/up.4c1f9a66.svg";